module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image4b.fa50b113.jpg";